export default __webpack_public_path__ + "static/media/findFriends.7e9f93a0.png";